<template lang="pug">
  .record-xml
    .record-xml-section
      template(v-for="(data, key) in xmlData")
        hr(v-if="key !== 'lei'")
        div.xml-header
          template(v-if="hasNodes(data)")
          h3 {{ sectionName(key) }}
        div.xml-group(v-if="!loading")
          template(v-for="(record, key) in data")
            div.xml-body(v-if="record.lei && record.xml != ''")
              div(v-if="hasNodes(data)")
                details(open)
                  summary
                    span(v-if="hasNodes(data)") {{ key }}
                  <pre v-if="record.lei" v-highlightjs :data-testid="`xml-${key}-data`">
                    <code class="xml" v-if="record.xml">{{ decode(record.xml) }}</code>
                  </pre>
              div(v-else)
                <pre v-if="record.lei" v-highlightjs :data-testid="`xml-${key}-data`">
                  <code class="xml" v-if="record.xml">{{ decode(record.xml) }}</code>
                </pre>
            div.xml-empty(v-else)
              .xml-title
                h4 {{ sectionName(key) }}
                  span(:data-testid="`xml-${key}-data`")  - None
        template(v-else)
          loading
</template>
<script>

import { mapState, } from 'vuex'
import Loading from '@/components/lei-components/Loading'
import he from 'he'

export default {
  name: 'RecordXml',
  components: {
    Loading,
  },
  computed: {
    ...mapState('record', [ 'xmlData', 'loading', ]),
  },
  methods: {
    decode (string) {
      return he.decode(string)
    },
    hasNodes (data) {
      return Object.keys(data).length > 1
    },
    sectionName (key) {
      switch (key) {
      case 'lei':
        return 'LEI Record'
      case 'rr':
        return 'Relationship Records (RR)'
      case 'repex':
        return 'Reporting Exceptions (REPEX)'
      default:
        return key
      }
    },
  },
}
</script>
<style src="../../../node_modules/highlight.js/styles/docco.css">
</style>
<style scoped>
.hljs {
  background: #fafaf9;
}

.record-xml-section .xml-header,
.record-xml-section .xml-body .xml-title
{
   display:flex;
   align-items:center;
   gap: 0.5rem
}
.record-xml-section .xml-header h3 {
  text-transform:uppercase;
  font-weight:bold;
  font-size: 1rem
}
.record-xml-section .xml-empty .xml-title {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 1rem
}
.record-xml-section .xml-empty .xml-title h4,
.record-xml-section .xml-body h4 {
   font-size: 1.05rem;
   font-weight:600;
   padding: 0.5rem 0 1rem 0
}
.record-xml-section .xml-empty span {
  color: #a8a29e;
}
.title-icon {
   margin-top: -0.5rem
}
details > summary {
  cursor:pointer;
  padding-bottom: 0.5rem;
  padding-top: 0.5rem;
}
details > summary > span {
  font-size: 1.05rem;
  font-weight:600;
}

.xml-group {
  border-left: 2px solid #e0e0e0;
  margin-bottom: 1rem;
  margin-top: 10px;
  padding: 0;
}
.xml-body {
  margin-left: 10px;
}

hr {
  margin: 1.5rem 0;
  border-top: 1px solid #f4f4f4;
}

</style>



// WEBPACK FOOTER //
// src/components/record-details/RecordXml.vue